// 注意: 梳理发现，此文件线上未被引用，如需使用请同步上传rainbow

const ENV = process.env.NODE_ENV || 'production';
// const argv = require('minimist')(process.argv.slice(2));
// const fs = require('fs');
// const path = require('path');
const interfaceConfig = require('./interface');
// const midasConfig = require('./midas');

// 区域配置
// const { region, snapshotConfig } = require('./region');

// 项目名
// const PROJECT_NAME = 'qcmain';

const config = {
  env: ENV,
  // region,
  // PROJECT_NAME,
  // midasConfig,
  // defaultLocale: 'en',
  // host: argv.host || '127.0.0.0',
  // port: argv.port || '3003',
  // ROUTE_BASE_PATH: '',
  // // 微信 mfa 二维码模式：weapp | h5
  // wxMfaQrcodeMode: 'weapp',

  // // specify log level for `./libs/logger`
  // // 可选值: debug, info, warn, error
  // logLevel: 'debug',

  // // 日志打印路径（生产环境专用）
  // logPath: './logs',

  // // socket超时时间(ms)
  // socketTimeout: 12 * 1000,

  // // session配置信息
  // sessionConfig: {
  //   name: `${PROJECT_NAME}.sid`,
  //   secret: `${PROJECT_NAME}_secret`,
  //   /**
  //    * @ignore
  //    * @see `instance/multi-domain.js`
  //    */
  //   cookieOptions: {
  //     path: '/',
  //     httpOnly: true,
  //     maxAge: null,
  //     domain: '.qcloud.com',
  //     secure: false,
  //   },
  // },

  // // 是否启用模调上报
  // enableDcReport: true,

  // // 图片验证码 APPID
  // ptAppId: 543009503,

  // // 快照设置
  // snapshotConfig,

  // forbiddenCountryCode: ['RU', 'UA', 'CN'],

  // // 禁止区域
  // forbiddenDistrict: ['RU', 'UA_Donetsk', 'UA_Luhansk'],

  // cosV5SecretId: '', // cosV5 secretId
  // cosV5SecretKey: '', // cosV5 secretKey

  // cosIntlSecretId: '', // secretId for intl cos
  // cosIntlSecretKey: '', // secretKey for intl cos

  // cosIntlOldSecretId: '', // secretId for intl cos
  // cosIntlOldSecretKey: '', // secretKey for intl cos

  // // 调用云 API 持久密钥，后台管理，用来换取用户的临时密钥
  // conSecretId: '', // 联调
  // conSecretKey: '', // 联调

  // thirdParty: {
  //   google: {
  //     enable: true,
  //     appId: '197198799412-9m5mt0khbiuofvs910s3972h4no0ih0h.apps.googleusercontent.com',
  //     appSecret: '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',
  //   },
  //   wechat: {
  //     enable: false,
  //     appId: '',
  //     appSecret: '',
  //   },
  // },
  // // 告警相关配置
  // alarmConfig: {
  //   // 是否开启接收告警消息
  //   enableAlarm: true,

  //   // 告警消息默认标题
  //   defaultTitle: `alarm from ${PROJECT_NAME}`,

  //   // 接收告警通知最小时间间隔，防止连续错误重复通知(单位：秒)
  //   timeInterval: 1800,

  //   // 告警短信接收者
  //   smsReceivers: ['svkingfang', 'breezmchen', 'lucillechen', 'robinxren'],

  //   // 告警邮件接收者
  //   emailReceivers: [
  //     'svkingfang@tencent.com',
  //     'breezmchen@tencent.com',
  //     'lucillechen@tencent.com',
  //     'robinxren@tencent.com',
  //   ],

  //   warningReceivers: ['svkingfang', 'breezmchen', 'lucillechen', 'robinxren'],
  // },

  ...interfaceConfig,
};

// // 本地创建 __local.js 可覆盖版本库配置
// __local.js 已添加到 .gitignore 所以不会提交和他人冲突
// if (fs.existsSync(path.resolve(__dirname, './__local.js'))) {
//   config = require('./__local')(config);
// }

module.exports = config;
